import { wrapWithProvider } from './src/store';
import './src/styles/fonts.css';

export const wrapRootElement = wrapWithProvider;
